module.exports = "<div class=\"about\">\n\n  <h1>{{$ctrl.title}}</h1>\n\n  <p>\n    This is a frivolous web app that exists only to demonstrate component\n    app structure with Angular 1.5, as well as a little ES2015 with Babel\n    and Webpack.\n  </p>\n\n  <p>\n    TODO: incorporate OMDb into this section.\n  </p>\n\n  <div class=\"frame\">\n    <img src=\"assets/images/cage34.gif\" alt=\"the cage\" title=\"Do I dazzle you?\" />\n  </div>\n  <span class=\"caption\">If this doesn't dazzle you I don't know what will.</span>\n\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/about/about.html
 ** module id = 83
 ** module chunks = 0
 **/